import { useAuthActions } from "@convex-dev/auth/react";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { Redirect } from "expo-router";
import React, { useCallback } from "react";
import { Linking, Pressable, Text, View } from "react-native";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import { AppBar } from "@/elements/components/ui/app-bar";
import { Status } from "@/elements/components/ui/status";
import { api } from "@/elements/components/utils/convex-api";

const BACKOFFICE_URL = process.env.EXPO_PUBLIC_BACKOFFICE_URL!;

function TutorStatusScreen() {
  const { signOut } = useAuthActions();

  const { data: tutorProfile, isSuccess } = useQuery(
    convexQuery(api.tutor.queries.getProfile, {}),
  );

  const isApproved = !!tutorProfile?.approvedAt;
  const hasKycRequest = !!tutorProfile?.kycRequestedAt;

  const { title, subtitle } = {
    title: hasKycRequest
      ? "KYC documents requested"
      : "Your application has been submitted.",
    subtitle: hasKycRequest
      ? "Please upload your Emirates ID (front and back) and bank proof to complete your verification. This helps us meet UAE verification standards."
      : "We will get back to you within two working days on the status of your application. Please keep an eye on your inbox for a message from us.",
  };

  const handleUploadDocuments = useCallback(() => {
    if (!tutorProfile?._id)
      return Toast.show({
        type: "error",
        text1: "Tutor not found",
        text2: "Please contact support: admin@loopedinlearning.io",
      });

    Linking.openURL(`${BACKOFFICE_URL}/kyc-upload/${tutorProfile._id}`);
  }, [tutorProfile?._id]);

  if (!isSuccess) {
    return <></>;
  }

  if (isApproved) {
    return <Redirect href={"/(app)/home"} />;
  }

  return (
    <View className="bg-teachLoop-creamDark flex-1">
      <AppBar>
        <AppBar.Icon onPress={() => signOut()} />

        <AppBar.Title>Sign Out</AppBar.Title>
      </AppBar>

      <Status className="justify-center px-5">
        <Status.Illustrator />

        <View className="h-[56]" />

        <Status.Title>{title}</Status.Title>

        <View className="h-[16]" />

        <Status.SubTitle>{subtitle}</Status.SubTitle>

        {hasKycRequest && (
          <>
            <View className="h-[24]" />

            <Pressable
              onPress={handleUploadDocuments}
              className="bg-teachLoop-accentPrimary rounded-xl px-6 py-3"
            >
              <Text className="text-white font-geologica-medium text-base text-center">
                Upload KYC Documents
              </Text>
            </Pressable>
          </>
        )}
      </Status>
    </View>
  );
}

export default TutorStatusScreen;
